module.exports = __webpack_public_path__ + "static/media/hi_click.eed6e990.wav";